export type FormFieldValidationErrorResponse = {
  field: string;
  message: string; // <= example: 'field.error.required'
};
